












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsEvolutionCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {};

  buldChartOptions() {
    this.chartOptions = {
      legend: {
        position: 'bottom'
      },
      height: 350,
      chartArea: { left: '60', top: '20', right: '20', bottom: '100' },
      fontSize: 12,
      hAxis: {
        slantedText: true,
        slantedTextAngle: 45
      },
      vAxis: {
        title: 'Visitas',
        minValue: 0,
        titleTextStyle: {
          italic: false
        }
      },
      series: {
        [0]: {
          color: '#102d69',
          lineWidth: 2,
          pointSize: 0
        },
        [1]: {
          color: '#0e743f',
          lineWidth: 2,
          pointSize: 0
        }
      }
    };
  }

  mounted() {
    this.buldChartOptions();
    this.load();
  }

  load() {
    this.chartData = [];
    let headers = ['Período', 'Planejadas', { role: 'annotation' }, 'Realizadas', { role: 'annotation' }];
    this.chartData.push(headers);
    this.kpis.forEach((o) => {
      this.chartData.push([o.descPeriodo, o.planejadas, o.planejadas, o.realizadas, o.realizadas]);
    });
  }

  @Watch('kpis', { immediate: true })
  @Watch('configs', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  getGoalPosition() {
    let names = new Set<string>();
    this.kpis.forEach((i) => {
      names.add(i.nome);
    });
    return names.size;
  }

}
